import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import {
  RideRadioButton,
  RideRadioButtonGroup,
  RideTextField,
} from "@rimac-seguros/ride-system-components";
import { CustomDropdown } from "@/components/molecules/CustomDropdown/index";
import { useJobService } from "@/services/job.service";
import { JOBS_LIMIT_SIZE } from "@/utils/awsConfig";

import "./styles.scss";

const FormJob = ({
  register,
  errors,
  setValue,
  watch,
  isSmallScreen,
}) => {
  const [viewCompany, setViewCompany] = useState(false);
  const [viewJob, setViewJob] = useState(false);

  const { getJobs } = useJobService();

  const { jobs, loading, success } = useSelector((state) => state.jobs);
  const { userData } = useSelector((state) => state.vida);

  useEffect(() => {
    if (!success) {
      getJobs();
    }
  }, [success]);

  useEffect(() => {
    const isWorking = watch("isWorking");
    setViewJob(!!isWorking);
    setViewCompany(isWorking === "Si");
  }, [watch("isWorking")]);

  const optionJobs = useMemo(
    () =>
      jobs.map((item) => ({
        label: item.label,
        value: item.value,
      })),
    [jobs]
  );

  return (
    <div id="form-job" className="form-job">
      <h3>Datos laborales</h3>
      <RideRadioButtonGroup
        label="¿Te encuentras laborando actualmente?"
        orientation="horizontal"
        error={!!errors?.isWorking}
        errorMessage="Campo requerido"
      >
        <RideRadioButton
          text="Sí"
          value="Si"
          {...register("isWorking", { required: true })}
        />
        <RideRadioButton
          text="No"
          value="No"
          {...register("isWorking", { required: true })}
        />
      </RideRadioButtonGroup>
      {viewJob && (
        <div className="form-job_data">
          <div className="form-job_input">
            <CustomDropdown
              name="job"
              label="Ocupación"
              titleModal="Ocupación"
              isShowModal={isSmallScreen}
              hasSearch
              iconResult="RideGlUserSolid"
              list={optionJobs || []}
              loading={loading}
              disabled={loading || optionJobs.length === 0}
              register={register}
              setValue={setValue}
              watch={watch}
              placeholder="¿A qué te dedicas?"
              virtualized={optionJobs.length >= Number(JOBS_LIMIT_SIZE)}
              error={!!errors?.job}
              errorMessage="Campo requerido"
              customClass="remove-icon-x-dropdown"
              isEmbedded={userData.indPrevPageApp}
              smallText={true}
            />
          </div>
          {viewCompany && (
            <div className="form-job_input">
              <RideTextField
                label="Empresa donde trabajas"
                size="large"
                aria-required
                {...register("company", {
                  required: true,
                  minLength: 3,
                })}
                autoComplete="off"
                error={!!errors?.company}
                errorMessage={
                  errors?.company?.type === "required"
                    ? "Este campo es obligatorio"
                    : "Debes ingresar mínimo 3 caracteres "
                }
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FormJob;
